import { gql } from '@apollo/client';

// This is a little awkward but it will allow us to easily request
// bankruptcy info across all accounts on the customer details page
export const CUSTOMER_BANKRUPTCY_LEGAL_INFO = gql`
  query GetCustomerBankruptcyLegalInfo(
    $customerId: String!
    $creditAccountIds: [String!]
  ) {
    customer(customerId: $customerId) {
      id
      creditAccounts(accountIds: $creditAccountIds) {
        id
        cardDetails {
          id: accountId
          productDisplayName {
            productCode
            productName
          }
          last4
        }
        bankruptcyLegalInfo {
          caseNumber
          chapter
          dateFiled
          stage
          withdrawnDismissedDate
        }
      }
    }
  }
`;
